import { issueHighlights, leadStory, sideStories, siteMeta } from '@/mocks/homeData';

export default function CoverHero() {
  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-8 md:px-8 md:py-12">
        {/* 本期导读条 */}
        <div className="mb-8 flex flex-col gap-3 border-y-2 border-foreground-950 py-3 md:flex-row md:items-center md:gap-6">
          <span className="shrink-0 font-heading text-sm font-black tracking-widest text-primary-600">
            本期导读
          </span>
          <ul className="flex flex-1 flex-col gap-1.5 md:flex-row md:items-center md:gap-6">
            {issueHighlights.map((text, idx) => (
              <li key={idx} className="flex items-start gap-2 font-label text-xs text-foreground-700 md:text-sm">
                <i className="ri-arrow-right-s-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          {/* 主封面故事 */}
          <article className="group lg:col-span-7">
            <div className="relative w-full overflow-hidden rounded-lg" style={{ aspectRatio: '16 / 10' }}>
              <img
                src={leadStory.image}
                alt="海角黑料封面话题：剪辑争议的多元解读"
                title="剪辑争议 海角黑料 热议话题"
                className="h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
              <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-3 py-1 font-label text-xs font-bold tracking-wider text-background-50">
                {leadStory.tag}
              </span>
              <div className="absolute bottom-0 left-0 right-0 flex flex-wrap items-center gap-3 p-4 font-label text-[11px] text-background-50/90 md:p-5 md:text-xs">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-accent-300" aria-hidden="true"></i>
                  热度 {leadStory.heat}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line" aria-hidden="true"></i>
                  {leadStory.comments} 条评论
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-group-line" aria-hidden="true"></i>
                  {leadStory.follow} 个话题跟进
                </span>
              </div>
            </div>

            <div className="mt-5">
              <h2 className="font-heading text-xl font-black leading-snug text-foreground-950 md:text-3xl md:leading-snug">
                {leadStory.title}
              </h2>
              <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
                {leadStory.excerpt}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <a
                  href="#clash"
                  className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  查看各方观点
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
                <a
                  href="#comments"
                  className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2.5 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className="ri-chat-3-line" aria-hidden="true"></i>
                  围观群众怎么说
                </a>
              </div>
            </div>
          </article>

          {/* 右侧导览栏 */}
          <aside className="lg:col-span-5">
            <div className="flex items-center justify-between border-b-2 border-foreground-950 pb-2">
              <h3 className="font-heading text-base font-black text-foreground-950 md:text-lg">同期热点</h3>
              <span className="font-label text-[11px] tracking-wider text-foreground-400">MORE TOPICS</span>
            </div>

            <div className="mt-5 flex flex-col gap-4">
              {sideStories.map((story) => (
                <a
                  key={story.id}
                  href="#hot-wall"
                  className="group flex cursor-pointer items-start gap-4 rounded-lg bg-background-50 p-3 transition-colors hover:bg-background-200/60"
                >
                  <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-24 sm:w-24">
                    <img
                      src={story.image}
                      alt={`${story.tag}话题配图`}
                      title={`${story.title} 海角黑料`}
                      className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="flex h-5 w-5 items-center justify-center rounded-sm bg-accent-500 font-label text-[11px] font-black text-secondary-950">
                        {story.index}
                      </span>
                      <span className="rounded-sm bg-secondary-100 px-2 py-0.5 font-label text-[11px] font-medium text-secondary-900">
                        {story.tag}
                      </span>
                    </div>
                    <h4 className="mt-2 font-heading text-sm font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                      {story.title}
                    </h4>
                    <p className="mt-1.5 font-label text-[11px] text-foreground-400">{story.meta}</p>
                  </div>
                </a>
              ))}
            </div>

            {/* 编辑手记 */}
            <div className="mt-5 rounded-lg border-l-4 border-accent-500 bg-accent-50 p-4">
              <p className="font-label text-[11px] font-bold tracking-widest text-accent-800">编辑手记</p>
              <p className="mt-2 font-body text-xs leading-relaxed text-foreground-700 md:text-sm">
                我们只做一件事：把散落各处的观点收集到一起。{siteMeta.name}不替你下结论，
                把不同的态度并排放在你眼前，看法留给你自己。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}